import React, { useEffect, useState } from 'react';
import { Space, Table, Tag } from 'antd';
import WorkSpaceService from 'services/master/workspace';
import { formatDate } from "utils/date"
const columns = [

    {
        title: 'Shop',

        render: (_, record) => <>
            <div>
                <Space>
                    {record.web_site.title}
                    <a href={`https://${record.web_site.url}.sipro.store`} target='_blank'>Xem</a>
                </Space>


            </div>
            <div>
                {formatDate(record.create_on)}
            </div>

        </>,
    },


    {
        title: 'Liên hệ',

        render: (_, record) => <>
            <div>
                <Space>
                    {record.owner.phone}
                    {record.owner.full_name}
                </Space>


            </div>
            <div>

            </div>

        </>,
    },

];

const services = new WorkSpaceService();

const WorkSpaceList = () => {

    useEffect(() => {
        load();
    }, [])
    const [data, setData] = useState([])
    const load = async () => {
        var lst = await services.list();
        setData(lst);
    }

    return (
        <div>
            <Table columns={columns} dataSource={data} />
        </div>

    )

}


export default WorkSpaceList;